module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ws-314e33c2a444698f4bce5c7346cae980.svg";